<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="0.5" width="19" height="19" rx="9.5" stroke="#595959"/>
</svg>
